import { render, staticRenderFns } from "./NameValueWithDialog.vue?vue&type=template&id=a1c51afc&scoped=true"
import script from "./NameValueWithDialog.vue?vue&type=script&lang=js"
export * from "./NameValueWithDialog.vue?vue&type=script&lang=js"
import style0 from "./NameValueWithDialog.vue?vue&type=style&index=0&id=a1c51afc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c51afc",
  null
  
)

export default component.exports